import React from 'react';
import './HeroSection.css';


const HeroSection = ({ onScrollClick }) => {
  return (
    <>
    <section className="hero-section">
      
      <div className="hero-overlay"></div>


      
      <div className="hero-content">
        <h1 className="hero-title">ARCHMIPLAN</h1>
        <p className="hero-subtitle">
          Архитектурное бюро полного цикла — От концепции до реализации
          <br />
          
        </p>
      </div>
      
      {/* Стрелка для скролла */}
      <div className="scroll-arrow" onClick={onScrollClick}>
        <div className="arrow-down"></div>
      </div>
    </section>
    </>
  );
};

export default HeroSection;